import React from 'react';
import './FFaq.css';
import Navbar2 from '../../Components/Navbar2';


function FFaq ()  {
    return (
        <div className="faq-container slide-in">    
        <Navbar2 /> 
          <div className="mainfaq">
            {/* FAQ section */}
            <div className="faq">
              <h1>Frequently Asked Questions</h1>
              <p>Here are few topics that would help you navigate Cerify</p>
            </div>
            
            <div className="button-group">
              <a href="#Search" className="button">Search</a>
              <a href="#Gerneral" className="button">General</a>
              <a href="#Contracts" className="button">Contracts</a>
              <a href="#DataSharing" className="button">Data Sharing</a>
              <a href="#Verification" className="button">Verification</a>
              <a href="#Certification" className="button">Certification</a>
            </div>
    
            <div className="faq-content">
              <div className="general">
                <h3>GENERAL</h3>
                <div className="accordion">
                  <details>
                    <summary>Section 1</summary>
                    <p>This is the content of section 1.</p>
                  </details>
                  <details>
                    <summary>Section 2</summary>
                    <p>This is the content of section 2.</p>
                  </details>
                  <details>
                    <summary>Section 3</summary>
                    <p>This is the content of section 3.</p>
                  </details>
                </div>
              </div>
    
              <div className="contract">
                <h3>CONTRACT</h3>
                <div className="accordion">
                  <details>
                    <summary>Section 1</summary>
                    <p>This is the content of section 1.</p>
                  </details>
                  <details>
                    <summary>Section 2</summary>
                    <p>This is the content of section 2.</p>
                  </details>
                  <details>
                    <summary>Section 3</summary>
                    <p>This is the content of section 3.</p>
                  </details>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
}

export default FFaq;